import { Component, OnInit } from '@angular/core';
import { User } from '../../../shared/models/user';
import { MatDialog } from '@angular/material/dialog';
import { AlterarSenhatDialogComponent } from '../dialogs/alterar-senha/alterar-senha-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertType } from '../../../shared/models/alertType';
import { UsersService } from '../../../core/services/users.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { showAlertDialog } from '../../../shared/helpers/showAlertDialog';
@Component({
  selector: 'app-perfil',
  imports: [FormsModule, CommonModule, MatIconModule, ReactiveFormsModule],
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.scss'
})
export class PerfilComponent implements OnInit {
  user: User | null = null;
  imageUrl: string = '';
  userForm: FormGroup;
  emailFocused: boolean = false;
  private originalValues: { email: string; nomeCompleto: string } = { email: '', nomeCompleto: '' };
  private pendingAvatarFile: File | null = null;

  constructor(
    private userService: UsersService,
    private dialog: MatDialog,
    private fb: FormBuilder,
  ) {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      nomeCompleto: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.user = this.userService.currentUser();
    const initializeUser = (user: User) => {
      this.user = user;
      this.imageUrl = this.user?.avatarUrl || '';
      const email = this.user?.email || '';
      const nomeCompleto = this.user?.name || '';
      this.userForm.patchValue({ email, nomeCompleto });
      this.originalValues = { email, nomeCompleto };
    };

    if (!this.user) {
      this.userService.getUserInfo().subscribe({ next: initializeUser });
    } else {
      initializeUser(this.user);
    }
  }

  alterarSenha() {
    const dialogData = {
      user: this.user,
    };

    this.dialog.open(AlterarSenhatDialogComponent, {
      data: dialogData,
    });
  }

  onSubmit(): void {
    if (!this.user) {
      showAlertDialog(this.dialog, AlertType.Error, 'Erro', 'Usuário inválido. Por favor, tente novamente.');
      return;
    }

    this.user.name = this.userForm.get('nomeCompleto')?.value;
    this.user.email = this.userForm.get('email')?.value;

    this.updateUserProfile();
  }

  private updateUserProfile(): void {
    const pendingFile = this.pendingAvatarFile;

    this.userService.updateProfile(this.user!.name, this.user!.email).subscribe({
      next: () => {
        if (pendingFile) {
          this.userService.updateAvatar(pendingFile).subscribe({
            next: () => {
              this.userService.getUserInfo().subscribe({
                next: (user) => {
                  this.user = user;
                  this.imageUrl = user.avatarUrl || this.imageUrl;
                  this.originalValues = { ...this.userForm.value };
                  this.pendingAvatarFile = null;
                  showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'Os dados da sua conta foram alterados com sucesso!');
                }
              });
            }
          });
        } else {
          this.originalValues = { ...this.userForm.value };
          showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'Os dados da sua conta foram alterados com sucesso!');
        }
      }
    });
  }

  onFileChange(event: any): void {
    const reader = new FileReader();
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (files && files.length > 0) {
      const file = files[0];

      if (!file.type.startsWith('image/')) {
        showAlertDialog(this.dialog, AlertType.Error, 'Erro', 'Selecione um arquivo de imagem válido (JPG, PNG, GIF)');
        input.value = '';
        return;
      }

      const maxSizeInBytes = 5 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        showAlertDialog(this.dialog, AlertType.Error, 'Erro', 'O arquivo deve ter no máximo 5MB');
        input.value = '';
        return;
      }

      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
      };

      reader.readAsDataURL(file);
      this.pendingAvatarFile = file;
      input.value = '';
    }
  }

  getImageUrl(): string {
    return this.user?.avatarUrl && this.user.avatarUrl == this.imageUrl
      ? this.user.avatarUrl
      : this.imageUrl;
  }

  get nomeCompleto() {
    return this.userForm.get('nomeCompleto');
  }

  get email() {
    return this.userForm.get('email');
  }

  get hasChanges(): boolean {
    const current = this.userForm.value;
    return current.email !== this.originalValues.email ||
           current.nomeCompleto !== this.originalValues.nomeCompleto ||
           this.pendingAvatarFile !== null;
  }

  getLastPasswordChangeText(): string {
    const lastChange = this.user?.passwordChangeDate;
    if (!lastChange) {
      return '';
    }

    const now = new Date();
    const diff = now.getTime() - new Date(lastChange).getTime();
    const diffInHours = Math.floor(diff / (1000 * 60 * 60));

    if (diffInHours < 1) {
      return 'menos de 1 hora';
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 1) {
      return `${diffInHours} ${diffInHours === 1 ? 'hora' : 'horas'}`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 1) {
      return `${diffInDays} ${diffInDays === 1 ? 'dia' : 'dias'}`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    if (diffInYears < 1) {
      return `${diffInMonths} ${diffInMonths === 1 ? 'mês' : 'meses'}`;
    }

    return `${diffInYears} ${diffInYears === 1 ? 'ano' : 'anos'}`;
  }
}
